import { v4 as uuidv4 } from 'uuid'
import momentJS from 'moment'
import 'moment/locale/ko'

export {
  merge,
  uniq,
  omit,
  isEqual,
  cloneDeep,
  range,
  uniqueId,
  debounce,
  assign,
  pick,
  partial,
  pickBy,
  isEmpty,
} from 'lodash-es'

export type rawType =
  // 필요한 타입은 더 추가해 주세요.
  | 'Undefined'
  | 'Null'
  | 'String'
  | 'Number'
  | 'Boolean'
  | 'Array'
  | 'Object'
  | 'Function'
  | 'Promise'
  | 'Date'
  | 'Map'
  | 'Set'
  | 'Symbol'
  | 'FormData'
  | 'File'
  | 'Regdddxp'

export const toRawType = (v: any): rawType => {
  return Object.prototype.toString.call(v).slice(8, -1) as rawType
}

export const uuid = uuidv4

export type DateFormat =
  | 'YYYY.MM'
  | 'YYYY.MM.DD'
  | 'YYYY.MM.DD hh:mm'
  | 'YY.MM.DD(ddd)'
  | 'YYYY.MM.DD(ddd)'
  | 'YYYY.MM.DD(ddd) hh:mm'
  | 'YYYY.MM.DD(ddd) hh:mm:ss'
  | 'YYYY.MM.DD hh:mm:ss'
  | 'YY.MM.DD hh:mm:ss'
  | 'YY.MM.DD(ddd) hh:mm:ss'
  | 'YYYY'
  | 'MM'
  | 'MM.DD'
  | 'MM.DD(ddd) hh:mm'
  | 'DD'
  | 'ddd'
  | 'YYYY-MM'
  | 'YYYY-MM-DD'
  | 'YYYY-MM-DD hh:mm'
  | 'YYYY-MM-DD hh:mm:ss'
  | 'MM/DD(ddd)'
  | 'MM.DD(ddd)'
  | 'hh:mm'
  | 'hh:mm:ss'
  | 'YY.MM.DD(ddd) hh:mm'
  | 'YYYY-MM-DD (ddd)'
  | 'YY.MM.DD'
  | 'YYYY.MM.DD (ddd)'
  | 'MMMM Do, YYYY'

export const moment = momentJS

export const formatDate = (date: Date | string, format: DateFormat) => {
  return moment(date).format(format)
}

export const fromNow = (date: Date | string) => {
  return moment(date).fromNow()
}
